import Cookies from 'js-cookie';

type TokenPair = {
  access: string;
  refresh: string;
};

const LEGACY_DOMAIN = '.vegasimulator.com';
const ACCESS_COOKIE = 'maAccessToken';
const REFRESH_COOKIE = 'maRefreshToken';
const LEGACY_COOKIE = 'maToken';

const removeCookieEverywhere = (name: string) => {
  Cookies.remove(name);
  Cookies.remove(name, { path: '/', domain: LEGACY_DOMAIN });
};

export const getAccessToken = () => Cookies.get(ACCESS_COOKIE) || '';

export const getRefreshToken = () => Cookies.get(REFRESH_COOKIE) || '';

export const setAuthTokens = ({ access, refresh }: TokenPair) => {
  Cookies.set(ACCESS_COOKIE, access);
  Cookies.set(REFRESH_COOKIE, refresh);
  removeCookieEverywhere(LEGACY_COOKIE);
};

export const clearAuthTokens = () => {
  removeCookieEverywhere(ACCESS_COOKIE);
  removeCookieEverywhere(REFRESH_COOKIE);
  removeCookieEverywhere(LEGACY_COOKIE);
};
